import type { BudgetTranslations } from "../../types/budget";

export const budget: BudgetTranslations = {
  title: "Budget",
  manageBudgetFor: "Manage budget for {buildingName}",
  distribution: "Budget Distribution",
  monthlyForecast: "12 Month Forecast",
  details: "Budget Details",
  tabs: {
    distribution: "Distribution",
    overview: "Overview",
    costs: "Costs",
    payments: "Payments",
    forecasts: "Forecasts",
  },
  metrics: {
    netAreaTooltip: "The usable floor area of the building",
    addAreaData: "Add building area data",
    costPerM2Tooltip: "Total budget divided by net area",
    costPerM2Range: "Typical range: \u20AC1,500-\u20AC3,000/m\u00B2",
    addBudgetData: "Add budget data to calculate",
    belowAverage: "Below average cost",
    aboveAverage: "Above average cost",
    withinRange: "Within typical range",
    complete: "Complete",
    areaSetAddBudget: "Area set, add budget",
    missingData: "Missing area & budget",
    totalBudgetTooltip: "Sum of all budget categories",
    includesAllItems: "Includes all cost items",
    noBudgetItems: "No budget items added yet",
  },
  costs: {
    newSubcategory: "New Sub-category",
    total: "Total: {amount}",
    name: "Name",
    value: "Value",
    general: "General",
    categories: {
      preparationCosts: "Preparation Costs",
      siteInvestigation: "Site Investigation",
      designFees: "Design Fees",
      permits: "Permits",
      externalStructures: "External Structures",
      landscaping: "Landscaping",
      parkingAreas: "Parking Areas",
      fencing: "Fencing",
      foundation: "Foundation",
      excavation: "Excavation",
      concreteWork: "Concrete Work",
      waterproofing: "Waterproofing",
      loadBearingStructures: "Load-bearing Structures",
      steelFramework: "Steel Framework",
      concreteColumns: "Concrete Columns",
      floorSlabs: "Floor Slabs",
      facadeAndRoofing: "Facade Elements and Roofing",
      externalWalls: "External Walls",
      windows: "Windows",
      roofingMaterials: "Roofing Materials",
      interiorWallsCeilings: "Interior Walls and Ceilings",
      partitionWalls: "Partition Walls",
      ceilingSystems: "Ceiling Systems",
      wallFinishes: "Wall Finishes",
      fixturesEquipment: "Fixtures and Equipment",
      bathroomFixtures: "Bathroom Fixtures",
      kitchenEquipment: "Kitchen Equipment",
      builtInFurniture: "Built-in Furniture",
      technicalSystems: "Technical Systems",
      hvac: "HVAC",
      electrical: "Electrical",
      plumbing: "Plumbing",
      siteMaintenanceCosts: "Construction Site Maintenance",
      siteSecurity: "Site Security",
      temporaryFacilities: "Temporary Facilities",
      wasteManagement: "Waste Management",
      siteOverheads: "Construction Site Overheads",
      projectManagement: "Project Management",
      siteSupervision: "Site Supervision",
      insurance: "Insurance",
      coverageRiskGrowth: "Coverage, Risk, Growth",
      contingency: "Contingency",
      insuranceCoverage: "Insurance Coverage",
      growthMargin: "Growth Margin",
    },
  },
  payments: {
    completionPercentages: "Completion Percentages",
    savedSuccessfully: "Completion percentages saved successfully",
    saveFailed: "Failed to save completion percentages",
    summary: "Payment Summary",
    totalBudget: "Total Budget:",
    completedValue: "Completed Value:",
    previouslyPaid: "Previously Paid:",
    currentPayment: "Current Payment:",
    actGenerated: "Payment Act Generated",
    downloadedSuccessfully: "Your payment act has been downloaded successfully.",
    generateError: "Failed to generate payment act",
    generating: "Generating...",
    generateAct: "Generate Act",
    lastSaved: "Last saved: {time}",
    loadFailed: "Failed to load payments data",
    savePaymentsFailed: "Failed to save payments",
    noBudgetDataFound: "No budget data found",
  },
};
